<div class="sidebar-candidate-details"><app-loading [isLoading]="!!!candidate">@if (candidate) {
  <app-card [isHeaderLeft]="settings?.is_reference_score_enabled &amp;&amp; !!candidate.score">
    <div class="app-card-left"><app-score [score]="candidate.score" [radius]="45" [titleFontSize]="20"></app-score></div>
    <div class="app-card-right">
      <div class="row">
        <div class="col-12 col-md-6">
          <h3 class="h4">{{ candidate.full_name }}</h3>
          <div class="text-muted small">{{ 'COMMON.INTERNAL_ID' | translate }}: {{ candidate.internal_id || '-' }}</div>
          <div class="text-muted small">{{ 'CANDIDATES.SHOW.ADDED_BY' | translate }}: {{ candidate.added_by.user.full_name || '-' }} ({{ candidate.added_by.user.email }})</div>
        </div>
        <div class="col-12 col-md-6">
          <div class="btn-toolbar float-end mb-2"><button class="btn btn-light me-2 mb-4" type="button" (click)="getCandidate(true)" [tooltip]="'BUTTONS.REFRESH' | translate : { type : 'candidate' }" container="body"><i class="lnr lnr-refresh" aria-hidden="true"></i></button>@if (isEditable) {
          <button class="btn btn-light me-2 mb-4" type="button" (click)="openModal()" [tooltip]="'BUTTONS.EDIT' | translate : { type : 'candidate' }" container="body"><i class="lnr lnr-pencil" aria-hidden="true"></i></button>
          }<button class="btn btn-outline-danger me-2 mb-4" type="button" (click)="openDeleteModal()" container="body"><span>{{ 'BUTTONS.DEACTIVATE' | translate }}</span></button>@if (canPurgeData) {
          <button class="btn v-btn-danger me-2 mb-4" type="button" (click)="openAnonymizeModal()" container="body"><span>{{ 'BUTTONS.PURGE_DATA' | translate }}</span></button>
        }</div>
      </div>
    </div>
  </div>
</app-card>
}@if (candidate?.notes) {
<h5 class="title mt-4 mb-2">{{ 'SIDEBAR.CANDIDATE_NOTES' | translate }}</h5>
<div class="card v-card">
  <div class="card-body">
    <p class="mb-0">{{ candidate.notes }}</p>
  </div>
</div>
}
<h5 class="title mt-4 mb-2">{{ 'SIDEBAR.DEVICE_INFORMATION' | translate }}</h5>
@if (candidate) {
  <div class="card v-card">
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-md-6">
          <h5 class="card-title">{{ 'SIDEBAR.IP_ADDRESS' | translate }}</h5>
          <p class="text-muted">{{ candidate?.metadatum?.ip_address || '-' }}</p>
          <h5 class="card-title">{{ 'SIDEBAR.BROWSER' | translate }}</h5>
          <p class="text-muted">{{ candidate?.metadatum?.browser || '-' }}</p>
          <h5 class="card-title">{{ 'SIDEBAR.BROWSER_VERSION' | translate }}</h5>
          <p class="text-muted">{{ candidate?.metadatum?.browser_version || '-' }}</p>
          <h5 class="card-title">{{ 'SIDEBAR.DEVICE' | translate }}</h5>
          <p class="text-muted">{{ candidate?.metadatum?.device || '-' }}</p>
          <h5 class="card-title">{{ 'SIDEBAR.OS' | translate }}</h5>
          <p class="text-muted">{{ candidate?.metadatum?.os || '-' }}</p>
          <h5 class="card-title">{{ 'SIDEBAR.OS_VERSION' | translate }}</h5>
          <p class="text-muted">{{ candidate?.metadatum?.os_version || '-' }}</p>
          <h5 class="card-title">{{ 'SIDEBAR.USER_AGENT' | translate }}</h5>
          <p class="text-muted">{{ candidate?.metadatum?.user_agent || '-' }}</p>
        </div>
        <div class="col-12 col-md-6">
          <h5 class="card-title">{{ 'COMMON.CREATED_AT' | translate }}</h5>
          <p class="text-muted">{{ $safeNavigationMigration(candidate?.created_at) | dateFormat : 'MMM DD, YYYY hh:mma' }}</p>
          <h5 class="card-title">{{ 'COMMON.UPDATED_AT' | translate }}</h5>
          <p class="text-muted">{{ $safeNavigationMigration(candidate?.updated_at) | dateFormat : 'MMM DD, YYYY hh:mma' }}</p>@if (!!candidate?.signature_url) {
          <h5 class="card-title">{{ 'SIDEBAR.SIGNATURE' | translate }}</h5><img class="w-50" [src]="candidate.signature_url" />
        }
      </div>
    </div>
  </div>
</div>
}
</app-loading></div><app-modals-candidates [openModal]="openCandidateModal" [afterSubmit]="afterSubmit"></app-modals-candidates><app-modals [title]="'CANDIDATE.CONFIRM.TITLE'" [openModal]="openConfirmModal" [closeModal]="closeModal" [whenModalClose]="delete" [deleteKey]="'BUTTONS.DELETE' | translate" [isButtonsDisabled]="isButtonsDisabled">
<p [innerHTML]="'CANDIDATE.CONFIRM.DESCRIPTION' | translate : { fullName: $safeNavigationMigration(candidate?.full_name) }"></p>
</app-modals><app-modals [title]="'CANDIDATE.ANONYMIZE.TITLE' | translate" [openModal]="openAnonymizeConfirmModal" [closeModal]="closeModal" [whenModalClose]="anonymize" [deleteKey]="'BUTTONS.PURGE_DATA' | translate" [isButtonsDisabled]="isButtonsDisabled">
<p [innerHTML]="'CANDIDATE.ANONYMIZE.DESCRIPTION' | translate : { fullName: $safeNavigationMigration(candidate?.full_name) }"></p>
</app-modals>
